<form [formGroup]="filterForm" class="w-full">
   <div *ngFor="let dropdown of multiDropdowns.dropdowns; let i = index" class="w-full max-width">
      <p-dropdown
         *ngIf="dropdown.type === 'dropdown'"
         [options]="dropdown.options"
         [formControlName]="'dropdown-' + i"
         [placeholder]="dropdown.label"
         class="w-full md:w-80"
         styleClass="w-full md:w-80"
      ></p-dropdown>

      <p-multiSelect
         *ngIf="dropdown.type === 'multiselect'"
         [options]="dropdown.options"
         [formControlName]="'dropdown-' + i"
         [placeholder]="'Select' + dropdown.label"
         class="w-full md:w-80"
         styleClass="w-full md:w-80"
      ></p-multiSelect>

      <p-treeSelect
         *ngIf="dropdown.type === FilterType.TreeSelect"
         [options]="dropdown.options"
         [placeholder]="'DATA.COMMON.ACTIONS.SELECT_PLACEHOLDER' | translate: { placeholder: dropdown.label }"
         [formControlName]="'dropdown-' + i"
         [metaKeySelection]="false"
         containerStyleClass="w-full"
         display="chip"
         selectionMode="checkbox"
         filter="true"
         class="w-full md:w-80"
      ></p-treeSelect>

      <p-divider *ngIf="i < multiDropdowns.dropdowns.length - 1" align="center"> <b>de</b></p-divider>
   </div>
</form>
